import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

const CATEGORY_COLORS: Record<string, string> = {
  movie: 'bg-primary-500/20 text-primary-400',
  tv: 'bg-accent-500/20 text-accent-400',
  anime: 'bg-green-500/20 text-green-400',
  variety: 'bg-orange-500/20 text-orange-400',
};

const CATEGORY_NAMES: Record<string, string> = {
  movie: '电影',
  tv: '剧集',
  anime: '动漫',
  variety: '综艺',
};

export default function UpdateSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-1 h-5 rounded-full bg-accent-500"></div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                最新更新
              </h2>
            </div>
            <p className="text-sm text-foreground-500">实时追踪最新上线的影视资源</p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-accent-400">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/50 overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2">
            {latestUpdates.map((item, index) => (
              <Link
                key={item.id}
                to={`/article/${item.id}`}
                className={`flex items-center gap-4 px-5 py-3.5 hover:bg-background-200/40 transition-colors cursor-pointer ${
                  index < latestUpdates.length - 2
                    ? 'border-b border-background-200/50 md:border-b'
                    : ''
                } ${
                  index % 2 === 0
                    ? 'md:border-r md:border-background-200/50'
                    : ''
                } ${
                  index >= latestUpdates.length - 2 ? 'border-b-0' : ''
                }`}
              >
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center">
                  <i className="ri-play-circle-line text-lg text-foreground-400"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-100 truncate">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className={`text-xs px-1.5 py-0.5 rounded ${CATEGORY_COLORS[item.category]}`}>
                      {CATEGORY_NAMES[item.category]}
                    </span>
                    <span className="text-xs text-foreground-600">
                      {item.episode}
                    </span>
                  </div>
                </div>
                <div className="flex-shrink-0 text-xs text-foreground-600 whitespace-nowrap">
                  {item.updateTime}
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-lg bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-300 hover:text-foreground-100 transition-all duration-200 cursor-pointer"
          >
            查看全部更新
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}